module.exports = __webpack_public_path__ + "img/img05.d3d404d6.png";